const dateTimeFormats = {
  en: {
    short: { year: "numeric", month: "short", day: "numeric" }
  },
  ru: {
    short: { year: "numeric", month: "long", day: "numeric" }
  }
}

export default dateTimeFormats
